import { useContext } from 'react';
import { NavigationRouteContext } from '@react-navigation/native';
import type { GoodsRouteParams } from '../../../hooks/useGoodsRoute';
import { GoodsParamsContext } from '../context/GoodsParamsContext';

export const useGoodsSno = (): number => {
  const injected = useContext(GoodsParamsContext);
  // route 가 없으면 throw 하는 useRoute 대신 context 를 직접 읽어, 주입(찜탭 등) 케이스를 허용.
  const route = useContext(NavigationRouteContext);

  if (injected) {
    return injected.goodsId;
  }

  const params = route?.params as GoodsRouteParams['GoodsDetail'];
  return params.goodsId;
};
